<template>
    <div>
        <div class="sup-logo">
            <div>
                <SupsisLogoPurple />
                <div>
                    <button class="btn-404" @click="btnHome">{{ $t("message.page404GoToDashboard") }}</button>
                    <a href="https://supsis.com/">
                        <button class="btn-404" style="right: 60%">{{ $t("message.page404GoToSupsis") }}</button>
                    </a>
                </div>
            </div>
        </div>
        <img src="/static/img/Page404.svg" alt="404" class="error-svg" />
    </div>
</template>
<script>
import SupsisLogoPurple from "../../components/svg/SupsisLogoPurple.vue";


export default {
    name: "Page404",
    components: {
        SupsisLogoPurple,
    },
    methods: {
        btnHome() {
            this.$router.push("/");
        },
    },
};
</script>
<style lang="scss">
.sup-logo {
    width: 400px;
    height: 400px;
    position: absolute;
    left: 70%;
    top: 30%;
}

.btn-404 {
    background: transparent;
    color: gray;
    border: 1px solid #fe6244;
    background: transparent;
    color: #5022d1;
    border: 1px solid #fe6244;
    font-size: 15px;
    padding: 10px;
    border-radius: 50px;
    position: absolute;
    right: 30%;
    top: 50%;
}

@media (max-width: 768px) {
    .sup-logo {
        width: 400px !important;
        height: 400px !important;
        position: absolute !important;
        left: 0 !important;
        top: 30% !important;
    }
}
</style>
